import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AcademyRepository } from '../../../domain/repositories/academy.repository';
import { CategoryacademyImplementationRepositoryMapper } from './mappers/category-academy.repository.mapper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  CategoryAcademyModel,
  DataCategoryAcademyModel,
} from '../../../domain/models/academy/category-academy.model';
import { CategoryAcademyEntity } from './entities/category-academy.entity';
import { ContentAcademyImplementationRepositoryMapper } from './mappers/content-academy.repository.mapper';
import {
  ContentAcademyModel,
  DataContentAcademyModel,
} from '../../../domain/models/academy/content-academy.model';
import { ContentAcademyEntity } from './entities/content-academy.entity';

import { ContentResourceImplementationRepositoryMapper } from './mappers/content-resource.repository.mapper';

import {
  ContentResourceModel,
  DataContentResourceModel,
} from '../../../domain/models/academy/content-resource.model';

import { ContentResourceEntity } from './entities/content-resource.entity';

import { TypeResourceImplementationRepositoryMapper } from './mappers/type-resource.repository.mapper';

import {
  DataTypeResourceModel,
  TypeResourceModel,
} from '../../../domain/models/academy/type-resource.model';

import { TypeResourceEntity } from './entities/type-resource.entity';

import { TypeMimeImplementationRepositoryMapper } from './mappers/type-mime.repository.mapper';

import {
  DataTypeMimeModel,
  TypeMimeModel,
} from '../../../domain/models/academy/type-mime.model';

import { TypeMimeEntity } from './entities/type-mime.entity';

@Injectable({
  providedIn: 'root',
})
export class AcademyImplementationRepository extends AcademyRepository {
  categoryacademy = new CategoryacademyImplementationRepositoryMapper();
  contentacademy = new ContentAcademyImplementationRepositoryMapper();
  contentresource = new ContentResourceImplementationRepositoryMapper();

  typeresource = new TypeResourceImplementationRepositoryMapper();

  typemime = new TypeMimeImplementationRepositoryMapper();

  url = environment.baseUrl;

  constructor(private http: HttpClient) {
    super();
  }

  override getCategoryAcademyAll(): Observable<CategoryAcademyModel> {
    return this.http
      .get<CategoryAcademyEntity>(`${this.url}/AcademiasCategoria/GetAll`)
      .pipe(map(this.categoryacademy.mapFrom));
  }

  override insertCategoryAcademy(
    params: DataCategoryAcademyModel,
  ): Observable<CategoryAcademyModel> {
    return this.http
      .post<CategoryAcademyEntity>(
        `${this.url}/AcademiasCategoria/Insert`,
        params,
      )
      .pipe(map(this.categoryacademy.mapFrom));
  }

  override updateCategoryAcademy(
    params: DataCategoryAcademyModel,
  ): Observable<CategoryAcademyModel> {
    return this.http
      .put<CategoryAcademyEntity>(
        `${this.url}/AcademiasCategoria/Update`,
        params,
      )
      .pipe(map(this.categoryacademy.mapFrom));
  }

  override getAllContentAcademy(): Observable<ContentAcademyModel> {
    return this.http
      .get<ContentAcademyEntity>(`${this.url}/AcademiasContenido/GetAll`)
      .pipe(map(this.contentacademy.mapFrom));
  }

  override insertContentAcademy(
    params: DataContentAcademyModel,
  ): Observable<ContentAcademyModel> {
    return this.http
      .post<ContentAcademyEntity>(
        `${this.url}/AcademiasContenido/Insert`,
        params,
      )
      .pipe(map(this.contentacademy.mapFrom));
  }

  override updateContentAcademy(
    params: DataContentAcademyModel,
  ): Observable<ContentAcademyModel> {
    return this.http
      .put<ContentAcademyEntity>(
        `${this.url}/AcademiasContenido/Update`,
        params,
      )
      .pipe(map(this.contentacademy.mapFrom));
  }

  override getContentAcademyById(
    params: DataContentAcademyModel,
  ): Observable<ContentAcademyModel> {
    return this.http
      .post<ContentAcademyEntity>(
        `${this.url}/AcademiasContenido/GetByAcademyCategoryId`,
        params,
      )
      .pipe(map(this.contentacademy.mapFrom));
  }

  override insertContentResource(
    params: DataContentResourceModel,
  ): Observable<ContentResourceModel> {
    return this.http
      .post<ContentResourceEntity>(
        `${this.url}/AcademiasContenidoRecurso/Insert`,
        params,
      )
      .pipe(map(this.contentresource.mapFrom));
  }

  override updateContentResource(
    params: DataContentResourceModel,
  ): Observable<ContentResourceModel> {
    return this.http
      .put<ContentResourceEntity>(
        `${this.url}/AcademiasContenidoRecurso/Update`,
        params,
      )
      .pipe(map(this.contentresource.mapFrom));
  }

  override getContentResourceById(
    params: DataContentResourceModel,
  ): Observable<ContentResourceModel> {
    return this.http
      .post<ContentResourceEntity>(
        `${this.url}/AcademiasContenidoRecurso/GetByAcademyCategoryId`,
        params,
      )
      .pipe(map(this.contentresource.mapFrom));
  }

  override getAllTypeResource(): Observable<TypeResourceModel> {
    return this.http
      .get<TypeResourceEntity>(`${this.url}/TiposRecurso/GetAll`)
      .pipe(map(this.typeresource.mapFrom));
  }

  override insertTypeResource(
    params: DataTypeResourceModel,
  ): Observable<TypeResourceModel> {
    return this.http
      .post<TypeResourceEntity>(`${this.url}/TiposRecurso/Insert`, params)
      .pipe(map(this.typeresource.mapFrom));
  }

  override updateTypeResource(
    params: DataTypeResourceModel,
  ): Observable<TypeResourceModel> {
    return this.http
      .put<TypeResourceEntity>(`${this.url}/TiposRecurso/Update`, params)
      .pipe(map(this.typeresource.mapFrom));
  }

  override getAllTypeMime(): Observable<TypeMimeModel> {
    return this.http
      .get<TypeMimeEntity>(`${this.url}/TiposMIME/GetAll`)
      .pipe(map(this.typemime.mapFrom));
  }

  override insertTypeMime(
    params: DataTypeMimeModel,
  ): Observable<TypeMimeModel> {
    return this.http
      .post<TypeMimeEntity>(`${this.url}/TiposMIME/Insert`, params)
      .pipe(map(this.typemime.mapFrom));
  }

  override updateTypeMime(
    params: DataTypeMimeModel,
  ): Observable<TypeMimeModel> {
    return this.http
      .put<TypeMimeEntity>(`${this.url}/TiposMIME/Update`, params)
      .pipe(map(this.typemime.mapFrom));
  }
}
